import DetailsActions from './DetailsActions';

export default DetailsActions;
